import { REVIEWS, BUSINESS } from "@/data";
import { SectionHeading } from "./Buttons";
import * as Icons from "lucide-react";

const Stars = ({ n }) => (
  <div className="flex items-center gap-0.5">
    {[1, 2, 3, 4, 5].map((i) => (
      <Icons.Star key={i} className={`w-4 h-4 ${i <= n ? "fill-amber-400 text-amber-400" : "text-slate-200"}`} />
    ))}
  </div>
);

export default function Reviews() {
  return (
    <section id="reviews" data-testid="reviews-section" className="relative py-20 md:py-28 px-4 md:px-8 bg-slate-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-end">
          <SectionHeading
            eyebrow="Social Proof"
            title={<>Trusted by the<br /><span className="text-brand-red">Miami Gardens community.</span></>}
            sub="Real reviews from real local customers who've trusted us with their phones, tablets, and tech."
            testid="reviews-heading"
          />

          <div className="card-soft p-6 md:p-8 flex items-center justify-between gap-6 shadow-md" data-testid="rating-badge">
            <div>
              <div className="flex items-center gap-3 mb-2">
                <span className="font-display text-5xl md:text-6xl font-black text-brand-navy">{BUSINESS.rating}</span>
                <div className="flex flex-col">
                  <Stars n={5} />
                  <span className="text-xs font-bold uppercase tracking-wider text-slate-500 mt-1">{BUSINESS.reviewCount}+ reviews</span>
                </div>
              </div>
              <a
                href={BUSINESS.reviewsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="rating-google-link"
                className="inline-flex items-center gap-2 text-sm font-bold text-brand-red hover:text-brand-red-dark"
              >
                Read on Google
                <Icons.ExternalLink className="w-3.5 h-3.5" />
              </a>
            </div>
            <div className="hidden sm:grid w-20 h-20 rounded-2xl bg-brand-red place-items-center glow-red shrink-0">
              <Icons.Award className="w-10 h-10 text-white" strokeWidth={2.2} />
            </div>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {REVIEWS.map((r, i) => (
            <div
              key={i}
              data-testid={`review-card-${i}`}
              className="card-soft card-soft-hover p-6"
            >
              <Icons.Quote className="w-6 h-6 text-brand-red/60 mb-3" />
              <p className="text-sm text-slate-700 leading-relaxed">"{r.text}"</p>
              <div className="mt-5 pt-5 border-t border-slate-100 flex items-center justify-between">
                <div>
                  <div className="font-display font-extrabold text-brand-navy text-sm">{r.name}</div>
                  <div className="text-xs text-slate-500 mt-0.5">{r.when}</div>
                </div>
                <Stars n={r.rating} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
